import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import {Grid} from '@material-ui/core';
import VisualizationContainer from '../visualization-container';
import RowsVisualizationConfiguration, {CONFIGURATION_CONST} from './rows-visualization-configuration';
import RowsVisualizationCanvas from './rows-visualization-canvas';
import primesArray from '../../data/primes-array'
import Typography from "@material-ui/core/es/Typography/Typography";

const styles = ({spacing}) => {
    return {
        gridItem: {
            padding: spacing(2),
        }
    };
};

const CONST = {
    defaults: {
        primeNumbersCount: 2000,
        numbersPerRow: 210,
        pixelsPerNumber: 4,
    },
};

function isFormValid(errors) {
    const firstErrorId = Object.keys(errors).find((key) => {return errors[key] === true});
    return firstErrorId === void(0);
}

class RowsVisualizationPage extends PureComponent {
    state = {
        primeNumbersCount: CONST.defaults.primeNumbersCount,
        numbersPerRow: CONST.defaults.numbersPerRow,
        pixelsPerNumber: CONST.defaults.pixelsPerNumber,
        errors: {
            primeNumbersCount: false,
            numbersPerRow: false,
            pixelsPerNumber: false,
        },
    };

    render() {
        const {classes} = this.props;
        const {primeNumbersCount, numbersPerRow, pixelsPerNumber} = this.state;

        return (
            <Grid container>
                <Grid item xs={12} className={classes.gridItem}>
                    <RowsVisualizationConfiguration
                        handleChange={this.handleConfigurationChange}
                        primeNumbersCount={primeNumbersCount}
                        numbersPerRow={numbersPerRow}
                        pixelsPerNumber={pixelsPerNumber}
                    />
                </Grid>
                {this.renderErrors()}
                {this.renderCanvas()}
            </Grid>
        );
    }

    renderErrors = () => {
        const {classes} = this.props;
        const {errors} = this.state;

        if (isFormValid(errors)) return;

        return (
            <Grid item xs={12} className={classes.gridItem}>
                <Typography variant='body1' color='error'>
                    All values must be integers greater than 0.
                </Typography>
            </Grid>
        )
    };

    renderCanvas = () => {
        const {classes} = this.props;
        const {primeNumbersCount, numbersPerRow, pixelsPerNumber, errors} = this.state;

        if (!isFormValid(errors)) return;

        const data = primesArray.slice(0, primeNumbersCount);
        const parsedNumbersPerRow = parseInt(numbersPerRow, 10);
        const parsedPixelsPerNumber = parseInt(pixelsPerNumber, 10);

        return (
            <Grid item xs={12} className={classes.gridItem}>
                <VisualizationContainer>
                    <RowsVisualizationCanvas
                        primeNumbers={data}
                        numbersPerRow={parsedNumbersPerRow}
                        pixelsPerNumber={parsedPixelsPerNumber}
                    />
                </VisualizationContainer>
            </Grid>
        )
    };

    handleConfigurationChange = (stateKey) => (event) => {
        const {errors} = this.state;
        const parsedValue = parseInt(event.target.value, 10);

        errors[stateKey] = (isNaN(parsedValue) || parsedValue < CONFIGURATION_CONST.minimumConfigurationIntegerValue);

        this.setState({
            [stateKey]: event.target.value,
            errors,
        });
    }
}

RowsVisualizationPage.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RowsVisualizationPage);
